import {Component, input, model} from '@angular/core';

@Component({
  selector: 'app-sidebar',
  imports: [],
  templateUrl: './sidebar.html',
  styleUrl: './sidebar.css'
})
export class Sidebar {
  isOpen = model.required<boolean>();
  height = input<string>('h-screen');

  onBackdropClick() {
    this.isOpen.set(false);
  }
}
